import { createSlice } from "@reduxjs/toolkit";

const criarVitrineSlice = createSlice({
  name: "criarVitrine",
  initialState: {
    currentStep: 0,
    formData: {
      brand: null,
      priceTable: null,
      initialDate: "",
      finalDate: "",
      untilSoldOut: false,
      name: "",
      paymentCondition: null,
      minimumValue: null,
      byLine: false,
      byOrder: false,
      description: "",
      minimumInvoice: null,
      minimumQuantityPerOrder: "",
    },
    selectedProducts: [],
    representatives: [],
    productFilters: {},
    representativeFilters: {
      publicType: "",
      search: "",
    },
  },
  reducers: {
    setCurrentStep: (state, { payload }) => {
      state.currentStep = payload;
    },
    updateFormData: (state, { payload }) => {
      state.formData = { ...state.formData, ...payload };
    },
    setSelectedProducts: (state, { payload }) => {
      state.selectedProducts = payload;
    },
    addProduct: (state, { payload }) => {
      const exists = state.selectedProducts.some(
        (p) => p.Codigo === payload.Codigo
      );
      if (!exists) {
        state.selectedProducts.push(payload);
      }
    },
    removeProduct: (state, { payload }) => {
      state.selectedProducts = state.selectedProducts.filter(
        (p) => p.Codigo !== payload
      );
    },
    updateProduct: (state, { payload }) => {
      const { codigo, updates } = payload;
      state.selectedProducts = state.selectedProducts.map((item) =>
        item.Codigo === codigo ? { ...item, ...updates } : item
      );
    },
    setRepresentatives: (state, { payload }) => {
      state.representatives = payload;
    },
    updateRepresentative: (state, { payload }) => {
      state.representatives = payload;
    },
    updateProductFilters: (state, { payload }) => {
      state.productFilters = { ...state.productFilters, ...payload };
    },
    setProductFilters: (state, { payload }) => {
      state.productFilters = payload;
    },
    updateRepresentativeFilters: (state, { payload }) => {
      state.representativeFilters = {
        ...state.representativeFilters,
        ...payload,
      };
    },
    resetVitrineData: (state) => {
      state.currentStep = 0;
      state.formData = {
        brand: null,
        priceTable: null,
        initialDate: "",
        finalDate: "",
        untilSoldOut: false,
        name: "",
        paymentCondition: null,
        minimumValue: null,
        byLine: false,
        byOrder: false,
        description: "",
        minimumInvoice: null,
        minimumQuantityPerOrder: "",
      };
      state.selectedProducts = [];
      state.representatives = [];
      state.productFilters = {};
      state.representativeFilters = {
        publicType: "",
        search: "",
      };
    },
  },
});

const { actions, reducer } = criarVitrineSlice;

export const {
  setCurrentStep,
  updateFormData,
  setSelectedProducts,
  addProduct,
  removeProduct,
  updateProduct,
  setRepresentatives,
  updateRepresentative,
  updateProductFilters,
  setProductFilters,
  updateRepresentativeFilters,
  resetVitrineData,
} = actions;

export default reducer;
